// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3fppi","overflowing":"ReadFullNote_overflowing__3JLJT"};